import { RefObject } from 'react'

import {
  createEffectHook,
  DataField,
  Form,
  FormPath,
  FormPathPattern
} from '@formily/core'
import { batch } from '@formily/reactive'
import { InputRef } from 'antd'

export const ON_INPUT_MOUNT = 'onInputMount'

export type InputMountPayload = {
  ref: RefObject<InputRef>
  form: Form
  field: DataField
}

/**
 * input 组件挂载 hook
 */
export const onInputMount = createEffectHook(
  ON_INPUT_MOUNT,
  (payload: InputMountPayload) =>
    (
      pattern: FormPathPattern,
      callback: (payload: InputMountPayload) => void
    ) => {
      if (
        FormPath.parse(pattern).matchAliasGroup(
          payload.field.address,
          payload.field.path
        )
      ) {
        batch(() => {
          callback(payload)
        })
      }
    }
)
